import { SelectionEntry } from "@app/components/core/SelectionEntry/SelectionEntry"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { useCustomNavigation, useNavigationData } from "@app/components/navigation/NavigationHandler"
import { emptyArray } from "@app/utils/objectUtils"
import { classNamez } from "@tecreation/funnel-components"
import { useCallback, useState } from "react"
import { useForm } from "react-hook-form"
import { TabletImmersiveRoomBase } from "../TabletImmersiveRoomBase"

export default function TabletImmersiveRoomBooking2() {
	const { push } = useCustomNavigation()
	const navData = useNavigationData()

	const [quantity, setQuantity] = useState(navData?.names?.length || 1)
	const [names, setNames] = useState(navData.names || [undefined])

	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm()

	const next = useCallback(() => {
		handleSubmit(() => {
			let nextNames = []
			names.map((e, i) => {
				let v = e
				if (v && v.length > 0 && i < quantity) {
					// we ignore the names that was inserted before the customer reduced the quantity
					nextNames.push(v)
				}
			})
			push("/tablet-immersive-room-3", undefined, { ...navData, names: nextNames })
		})()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [handleSubmit, names, navData, quantity])

	return (
		<TabletImmersiveRoomBase>
			<div>Gewählte Uhrzeit: {navData.option.timeFrom.slice(0, 5)}</div>
			<div>Verfügbare Plätze: {navData.option.restCount}</div>
			<div className="mt-4 mb-4">
				<SelectionEntry
					count={quantity}
					onAdd={() => {
						setQuantity(quantity + 1)
					}}
					onRemove={() => {
						setQuantity(quantity - 1)
					}}
					plusDisabled={quantity >= navData.option.restCount}
				>
					<span className="f2">Personen</span>
				</SelectionEntry>
			</div>
			{quantity > 0 ? (
				<>
					{emptyArray(quantity).map((__, i) => {
						return (
							<div key={i}>
								<Input
									label="Name"
									className={"mt-3" + classNamez({ "mt-0": i == 0, "mb-3": i === quantity - 1 } + "flex-0")}
									key={i}
									defaultValue={names[i]}
									formRegister={register("name" + i, {
										required: {
											value: true,
											message: "Pflichtfeld",
										},
										onChange: e => {
											let name = e.target.value
											let newNames = [...names]
											newNames[i] = name
											setNames(newNames)
										},
									})}
									errors={errors}
								/>
							</div>
						)
					})}
				</>
			) : null}
			<div className="mt-auto flex">
				<Button
					style="outlined"
					className="primary"
					onClick={() => {
						push("/tablet-immersive-room-1", undefined, { ...navData })
					}}
				>
					Zurück
				</Button>
				<Button style="secondary" className="ml-auto" disabled={names.length === 0} onClick={next}>
					Weiter
				</Button>
			</div>
		</TabletImmersiveRoomBase>
	)
}
